import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarVeiculosDs,
  criarAlvaraVeiculoDs,
} from "../../DataSources";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { Button, ScrollView } from "devextreme-react";
import { TextBox, Button as TextBoxButton } from "devextreme-react/text-box";
import VeiculosBox from "../veiculos/VeiculosBox";
import ShowError from "../../AppServices";
import { abrirDetalhe } from "../../lancamentosUtils";

var dataCorrente = new Date();

const _novoVeiculoTemplate = {
  exibirPesqVeiculo: false,
  exibirPreview: false,
  id: undefined,
  prefeituraId: undefined,
  _uiNumero: undefined,
  ano: dataCorrente.getFullYear(),
  data: dataCorrente,
  dataDeVencimento: dataCorrente,
  tipoValidade: 1,
  validade: new Date(dataCorrente.getFullYear(), 11, 31),
  exercicio: dataCorrente.getFullYear(),
  veiculoId: undefined,
  contribuinteId: undefined,
  autorizadorId: undefined,
  historico: "",
  mesesProporcional: null,
  placa: "",
  modelo: "",
  nome: "-",
  cpfCnpj: "-",
  preview: true,
  previewData: {
    nome: "",
    cpfCnpj: "",
    enderedoL1: "",
    enderecoL2: "",
    placa: "",
    modelo: "",
    ano: "",
    valor: undefined,
    situacao: "",
  },
};

export default class AlvaraVeiculoForm extends React.Component {
  constructor(props) {
    super(props);
    this.veiculoDs = criarVeiculosDs();
    this.alvaraVeiculosDs = criarAlvaraVeiculoDs();
    this.saidaProgramada = false;
    _novoVeiculoTemplate.prefeituraId = UserInfo.getPrefeitura();
    this.state =
      this.props.match.params.id == undefined ? _novoVeiculoTemplate : {};
    this.setVeiculoId = this.setVeiculoId.bind(this);
    this.setDadosVeiculo = this.setDadosVeiculo.bind(this);
    this.pesquisarVeiculo = this.pesquisarVeiculo.bind(this);
    this.onVeiculoSelecionadoPesquisa =
      this.onVeiculoSelecionadoPesquisa.bind(this);
    this.veiculoBoxRef = React.createRef();
    this.renderVeiculo = sysCodigoDescricao(
      () => this.state.veiculoId,
      this.setVeiculoId,
      () => this.state._uiDescricaoVeiculo,
      this.pesquisarVeiculo
    );
    this.setDadosVeiculo = this.setDadosVeiculo.bind(this);
    this.atualizarInfoVeiculo = this.atualizarInfoVeiculo.bind(this);
    this.renderInfoVeiculo = this.renderInfoVeiculo.bind(this);

    this.cancel = this.cancel.bind(this);
    this.renderTxtVeiculo = this.renderTxtVeiculo.bind(this);
    this.onExercicioAlterado = this.onExercicioAlterado.bind(this);
    this.atualizarHistorico = this.atualizarHistorico.bind(this);

    this.confirmarTela = this.confirmarTela.bind(this);
    this.confirmarPopup = this.confirmarPopup.bind(this);
    this.itemLeitura = this.itemLeitura.bind(this);
    this.itemLeituraMoeda = this.itemLeituraMoeda.bind(this);

    this.tipoValidadeOpcoes = {
      dataSource: [
        { id: 1, descricao: "Permanente" },
        { id: 2, descricao: "Provisório" },
        { id: 3, descricao: "Prorrogação" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  onExercicioAlterado(e) {
    if (e.event) {
      this.atualizarHistorico();
    }
  }

  atualizarHistorico() {
    const fPlaca = this.state.placa;
    const fModelo = this.state.modelo;
    const fExercicio = this.state.exercicio;

    const placaOk = fPlaca !== undefined && !fPlaca.length !== 0;
    const modeloOk = fModelo !== undefined && !fModelo.length !== 0;
    const exercicioOk = fExercicio !== undefined && fExercicio !== 0;

    if (placaOk && modeloOk && exercicioOk) {
      const historico = `REF. TLTA EXERCÍCIO ${fExercicio}\r\nVEÍCULO: ${fPlaca} - ${fModelo}`;
      this.setState({ historico });
    }
  }

  renderInfoVeiculo(data) {
    return (
      <React.Fragment>
        <div
          style={{
            width: "100%",
            height: "35px",
            display: "flex",
            alignItems: "center",
            backgroundColor: "#D7DBDD",
          }}
        >
          <div style={{ padding: "15px" }}>
            <span style={{ fontWeight: "bold", paddingRight: "5px" }}>
              CPF/CNPJ:
            </span>{" "}
            {this.state.cpfCnpj}
          </div>
          <div style={{ padding: "15px", flexGrow: "1" }}>
            <span style={{ fontWeight: "bold", paddingRight: "5px" }}>
              Nome/Razão Social
            </span>{" "}
            {this.state.nome}
          </div>
        </div>
      </React.Fragment>
    );
  }

  setVeiculoId(data) {
    this.setState({ veiculoId: data.value });
    this.atualizarInfoVeiculo();
  }

  atualizarInfoVeiculo() {
    this.veiculoDs
      .load({ filter: [["sequencial", "=", this.state.veiculoId]] })
      .then((result) => {
        console.log("veiculo", result);
        if (result.length !== 0) {
          this.setDadosVeiculo(result[0]);
        } else {
          this.setDadosVeiculo(undefined);
        }
        this.atualizarHistorico();
      })
      .catch((_) => this.setDadosVeiculoErro());
  }

  setDadosVeiculo(veiculo) {
    if (veiculo === undefined) {
      this.setState({
        placa: "",
        modelo: "",
        cpfCnpj: "-",
        nome: "-",
        contribuinteId: undefined,
      });
    } else {
      this.setState({
        placa: veiculo.placa,
        modelo: veiculo.modelo,
        cpfCnpj: veiculo.contribuinte.documentoFormatado,
        nome: veiculo.contribuinte.nome,
        contribuinteId: veiculo.contribuinte.sequencial,
      });
    }
  }

  setDadosVeiculoErro() {
    this.setState({ _uiNomeContribuinte: "<<ERRO>>" });
  }

  onVeiculoSelecionadoPesquisa(e) {
    this.setState({
      veiculoId: e.row.data.sequencial,
      exibirPesqVeiculo: false,
    });
    this.atualizarInfoVeiculo();
  }

  pesquisarVeiculo() {
    this.veiculoBoxRef.current.limparFiltro();
    this.setState({ exibirPesqVeiculo: true });
  }

  renderTxtVeiculo() {
    return (
      <TextBox value={this.state.veiculoId} onValueChanged={this.setVeiculoId}>
        <TextBoxButton
          name="btnPesquisa"
          location="after"
          options={{ icon: "search", onClick: this.pesquisarVeiculo }}
        />
      </TextBox>
    );
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.alvaraVeiculosDs
        .load({ filter: ["sequencial", "=", this.props.match.params.id] })
        .then((response) => {
          if (response.length < 1) {
            notify("Registro não encontrado.", "error");
            this.props.history.goBack();
          } else {
            const data = response[0];
            let autorizadorId;
            if (data.autorizador != undefined) {
              autorizadorId = data.autorizador.sequencial;
            }
            let novoEstado = {
              _uiNumero: data.numeroCompleto,
              sequencial: data.sequencial,
              numero: data.numeroLancamento,
              id: data.id,
              prefeituraId: data.prefeituraId,
              ano: data.ano,
              data: data.dataLancamento,
              dataDeVencimento: data.vencimentoAlvara,
              validade: data.validadeLancamento,
              exercicio: data.exercicio,
              veiculoId: data.veiculo.sequencial,
              contribuinteId: data.contribuinte.sequencial,
              autorizadorId: autorizadorId,
              historico: data.historico,
              placa: data.veiculo.placa,
              modelo: data.veiculo.modelo,
              nome: data.contribuinte.nome,
              cpfCnpj: data.contribuinte.documentoFormatado,
              preview: true,
              tipoValidade: data.tipoValidadeAlvara,
              mesesProporcional: data.mesesProporcional,
            };

            this.abrindo = true;

            this.setState(novoEstado);

            this.atualizarNomeContribuinte();
          }
        })
        .catch((erro) => {
          ShowError(erro);
          this.props.history.goBack();
        });
    }
  }

  itemLeitura(data) {
    if (this.state.previewData == undefined) {
      return <span></span>;
    }
    return <span>{this.state.previewData[data.dataField]}</span>;
  }

  itemLeituraMoeda(data) {
    let valor;
    if (this.state.previewData != undefined) {
      valor = this.state.previewData[data.dataField];
    }
    let str = "";
    if (valor !== undefined) {
      str = valor.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    }

    return <span>{str}</span>;
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={2}>
              <GroupItem caption="ALVARÁ DE VÉICULO" colSpan={2} colCount={4}>
                <SimpleItem
                  colSpan={1}
                  dataField={"_uiNumero"}
                  editorType={"dxTextBox"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Número" />
                </SimpleItem>

                <EmptyItem colSpan={3} />

                <SimpleItem
                  colSpan={1}
                  dataType={"date"}
                  dataField={"data"}
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Data" />
                </SimpleItem>

                <EmptyItem colSpan={3} />

                <SimpleItem
                  colSpan={1}
                  dataType={"date"}
                  dataField={"dataDeVencimento"}
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Vencimento" />
                </SimpleItem>

                <EmptyItem colSpan={3} />

                <SimpleItem
                  colSpan={1}
                  dataField={"validade"}
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Validade" />
                </SimpleItem>

                <EmptyItem colSpan={3} />

                <SimpleItem
                  colSpan={1}
                  dataField={"exercicio"}
                  editorType={"dxTextBox"}
                  editorOptions={{ onValueChanged: this.onExercicioAlterado }}
                >
                  <Label text="Exercício" />
                </SimpleItem>

                <EmptyItem colSpan={3} />

                <SimpleItem
                  colSpan={1}
                  dataField={"tipoValidade"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.tipoValidadeOpcoes}
                >
                  <Label text="Tipo" />
                </SimpleItem>

                <EmptyItem colSpan={3} />

                <SimpleItem colSpan={1} render={this.renderTxtVeiculo}>
                  <Label text="Veículo" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"placa"}
                  editorType={"dxTextBox"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Placa" />
                </SimpleItem>

                <SimpleItem
                  colSpan={2}
                  dataField={"modelo"}
                  editorType={"dxTextBox"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Modelo" />
                </SimpleItem>

                <SimpleItem
                  colSpan={4}
                  render={this.renderInfoVeiculo}
                ></SimpleItem>

                <SimpleItem
                  dataField={"historico"}
                  colSpan={4}
                  editorType="dxTextArea"
                  editorOptions={{ height: 90 }}
                >
                  <Label text="Histórico" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"mesesProporcional"}
                  editorType={"dxTextBox"}
                >
                  <Label text="Meses Proporcional" />
                </SimpleItem>

                <EmptyItem colSpan={3} />

              </GroupItem>
            </Form>
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Pré-visualizar"
                  type="default"
                  onClick={this.confirmarTela}
                />
              </div>

              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.confirmarPopup}
                />
              </div>

              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} />
              </div>
            </div>
          </form>
          <Popup
            visible={this.state.exibirPesqVeiculo}
            onHiding={() => this.setState({ exibirPesqVeiculo: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Veículo"
          >
            <ScrollView showScrollbar={"always"}>
              <VeiculosBox
                onSelecionado={this.onVeiculoSelecionadoPesquisa}
                ref={this.veiculoBoxRef}
              />
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ exibirPesqVeiculo: false }),
              }}
            ></ToolbarItem>
          </Popup>
          <Popup
            visible={this.state.exibirPopupPreview}
            onHiding={() => this.setState({ exibirPopupPreview: false })}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={600}
            height={350}
            title="Confirmação dos dados"
          >
            <ScrollView showScrollbar="always">
              <form>
                <Form formData={this.state.previewData}>
                  <SimpleItem dataField={"nome"} render={this.itemLeitura}>
                    <Label text="Nome" />
                  </SimpleItem>

                  <SimpleItem dataField={"cpfCnpj"} render={this.itemLeitura}>
                    <Label text="CPF/CNPJ" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"enderecoL1"}
                    render={this.itemLeitura}
                  >
                    <Label text="Endereco" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"enderecoL2"}
                    render={this.itemLeitura}
                  >
                    <Label text=" " showColon={false} />
                  </SimpleItem>

                  <SimpleItem dataField={"placa"} render={this.itemLeitura}>
                    <Label text="Placa" />
                  </SimpleItem>

                  <SimpleItem dataField={"modelo"} render={this.itemLeitura}>
                    <Label text="Modelo" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"valor"}
                    render={this.itemLeituraMoeda}
                  >
                    <Label text="Valor" />
                  </SimpleItem>
                  <SimpleItem dataField={"situacao"} render={this.itemLeitura}>
                    <Label text="Valor" />
                  </SimpleItem>
                </Form>
              </form>
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Confirmar",
                type: "success",
                width: 150,
                onClick: this.confirmarPopup,
              }}
            ></ToolbarItem>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Cancelar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ exibirPopupPreview: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  confirmarTela() {
    this.confirmar(this.state.preview);
  }

  confirmarPopup() {
    this.confirmar(false);
  }

  confirmar(preview) {
    let entidade = { ...this.state };
    entidade.preview = preview;
    inserirOuAtualizar(this.alvaraVeiculosDs, entidade).then(
      function (data) {
        if (preview) {
          this.setState({
            exibirPopupPreview: true,
            previewData: {
              nome: data.lancamento.contribuinte.nome,
              cpfCnpj: data.lancamento.contribuinte.documentoFormatado,
              enderecoL1: data.lancamento.contribuinte.logradouroComNumero,
              enderecoL2: data.lancamento.contribuinte.enderecoL2,
              placa: data.lancamento.veiculo.placa,
              modelo: data.lancamento.veiculo.modelo,
              ano: data.lancamento.veiculo.anoFabricaoEModelo,
              valor: data.lancamento.valorDoImposto,
              situacao: data.lancamento.situacao.descricao,
            },
          });
        } else {
          abrirDetalhe(this.props.history, data);
        }
      }.bind(this)
    );
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
